// Display name shown to users across the agent chat UI.
export const AGENT_NAME = 'ARIA';

// Drawer dimensions
export const DEFAULT_DRAWER_WIDTH = 522;
export const MIN_DRAWER_WIDTH = 420;
export const MAX_DRAWER_WIDTH = 1569;
// Set on <html> while the docked drawer is mounted so the main content area
// can reserve space for it (see MainContent in routes/AppWithRoutes.tsx).
export const DRAWER_WIDTH_CSS_VAR = '--wb-agent-drawer-width';
export const DRAWER_TOP_CSS_VAR = '--wb-agent-drawer-top';
// Minimum width the main content area keeps beside the docked drawer. The
// drawer reserves layout space only down to this floor; any drawer width
// beyond it overlays the content instead.
export const MIN_MAIN_CONTENT_WIDTH = 900;

// Queued-message list
export const QUEUE_ROW_HEIGHT = 46; // 32px content + 12px padding + 2px border
export const QUEUE_MAX_HEIGHT = QUEUE_ROW_HEIGHT * 4 + 4 * 3; // 4 rows + 4px gaps
// MIN_THREAD_HEIGHT floors the thread viewport while a queue is present, so
// queued messages can't push the conversation out of view.
export const MIN_THREAD_HEIGHT = 160;
